import "./styles.less";

import { List, Radio, Skeleton, Table, Typography } from "antd";
import { useEffect, useState } from "react";

import { PageLink } from "../../Link/web";
import { makePriceText } from "../../../Utils/Functions";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useUnits } from "./hook";
import { useRouter } from "next/router";
// import { useGoogleAnalytics } from "shared-components/GlobalHooks/web/GoogleAnalytics.hook";

interface UnitsProps {
	comertialUnits: CommercialUnit[];
	loading?: boolean;
}

export const Units = ({ comertialUnits, loading = false }: UnitsProps) => {
	const { query } = useRouter();
	const { filters, units, sendLead } = useUnits({ comertialUnits, utm: query });
	const [filterBy, setFilterBy] = useState("all");
	const [data, setData] = useState([]);
	const [asked, setAsked] = useState([]);
	const [relatedModal, setRelatedModal] = useState(false);
	const screen = useBreakpoint();

	useEffect(() => {
		if (filterBy === "all") {
			setData(units);
		} else {
			setData(filters[filterBy].units);
		}
	}, [units, filterBy]);

	const radioChange = e => {
		setFilterBy(e.target.value);
	};

	const askDisponibility = unitID => {
		sendLead(unitID).then(data => {
			if (data) {
				setAsked([...asked, unitID]);
				setRelatedModal(true);
			}
		});
	};

	if (loading) return <Skeleton active />;

	return (
		<div className="project-units-section">
			<Radio.Group
				className="project-units-filters"
				onChange={radioChange}
				value={filterBy}
				style={{ marginBottom: 15 }}>
				<Radio.Button value="all">
					{"Todos"} ({units.length})
				</Radio.Button>
				{filters.length > 1
					? filters.map((filter, i) => (
						<Radio.Button key={"unit_" + i} value={i}>
							{filter.beds == 0
								? `Mono (${filter.units.length})`
								: `${filter.beds} ${"dorm"} (${filter.units.length})`}{" "}
						</Radio.Button>
					))
					: null}
			</Radio.Group>

			{screen.lg && (
				<UnitsTable data={data} asked={asked} askDisponibility={askDisponibility} />
			)}

			{!screen.lg && (
				<UnitsList data={data} asked={asked} askDisponibility={askDisponibility} />
			)}
		</div>
	);
};

/**
 * Lists of Units Presentational componets
 */

// For responsive
const UnitsList = ({ data, asked, askDisponibility }: any) => {
	// const GA = useGoogleAnalytics();

	const triggerGAevent = (label: string) => {
		// GA.Event({
		// 	category: 'user_event',
		// 	action: 'unit_table_click',
		// 	label: label
		// })
	}

	return (
		<>
			<List
				itemLayout="horizontal"
				dataSource={data}
				renderItem={(item: any) => (
					<List.Item className="proyect_units_list_item">
						<div className="units_items">
							<div className="unit_item">
								<Typography.Text strong={true}>Referecia </Typography.Text>
								<PageLink callback={() => { triggerGAevent('ref') }} pathname="/singleProps" as={item.link}>
									#{item.code}
								</PageLink>
							</div>
							<div className="unit_item">
								<Typography.Text strong={true}>Dormitorios</Typography.Text>
								<span>{item.bedrooms === 0 ? "Mono" : `${item.bedrooms}`}</span>
							</div>
							<div className="unit_item">
								<Typography.Text strong={true}>{"Baños"} </Typography.Text>
								<span>{item.bathrooms}</span>
							</div>
							<div className="unit_item">
								<Typography.Text strong={true}>{"m² edif."} </Typography.Text>
								<span>{item.m2}</span>
							</div>
							<div className="unit_item">
								<Typography.Text strong={true}>{"Precio"} </Typography.Text>
								<span>{makePriceText(item.price)}</span>
							</div>
							<div className="unit_item">
								<Typography.Text strong={true}>
									{"Precio" + " / m²"}
								</Typography.Text>
								<span>
									{item.price &&
										item.m2 &&
										makePriceText({
											...item.price,
											amount: item.price.amount / item.m2,
										})}
								</span>
							</div>
						</div>
						<div className="units_ask_stuff">
							{asked.some(elem => elem == item.id) ? (
								<Typography.Text disabled>{"¡Preguntado!"}</Typography.Text>
							) : (
								<button className="btnText" onClick={() => {
									askDisponibility(item.id)
									triggerGAevent('ask_disponibility')
								}}>
									{"Averiguar Disponibilidad"}
								</button>
							)}
						</div>
					</List.Item>
				)}
			/>
		</>
	);
};

// For Desktop
const UnitsTable = ({ data, asked, askDisponibility }: any) => {
	// const GA = useGoogleAnalytics();

	const triggerGAevent = (label: string) => {
		// GA.Event({
		// 	category: 'user_event',
		// 	action: 'unit_table_click',
		// 	label: label
		// })
	}
	return (
		<>
			<Table dataSource={data} pagination={false} rowKey={rd => "unit_" + rd.id}>
				<Table.Column
					title={"Ref."}
					dataIndex="code"
					key="code"
					render={(code, row: any) => (
						<PageLink callback={() => { triggerGAevent('ref') }} pathname="/singleProps" as={row.link}>
							#{code}
						</PageLink>
					)}
				/>
				<Table.Column
					title={"Dormitorios"}
					dataIndex="bedrooms"
					key="bedrooms"
					render={bedrooms => (
						<>
							{bedrooms === 0
								? "Mono"
								: `${bedrooms} Dorm.`
							}
						</>
					)}
				/>
				<Table.Column
					title="Baños"
					dataIndex="bathrooms"
					key="bathrooms"
					render={bathrooms => <>{`${bathrooms} Baño${bathrooms != 1 ? 's' : ''}`}</>}
				/>
				<Table.Column
					title={"m² edificados"}
					dataIndex="m2"
					key="m2"
					render={m2 => <>{m2} m²</>}
					width={140}
				/>
				<Table.Column
					title={"Precio"}
					dataIndex="price"
					key="price"
					render={price => <>{makePriceText(price)}</>}
				/>
				<Table.Column
					title={"Precio" + " x m²"}
					dataIndex="price"
					key="pricePerm2"
					render={(price, row: any) => (
						<>
							{price &&
								row.m2 &&
								makePriceText({ ...price, amount: price.amount / row.m2 })}
						</>
					)}
				/>
				<Table.Column
					title=""
					key={"action_col"}
					render={row => {
						if (asked.some(elem => elem == row.id))
							return <Typography.Text disabled>{"¡Preguntado!"}</Typography.Text>;
						else
							return (
								<button className="btnText" onClick={() => {
									askDisponibility(row.id)
									triggerGAevent('ask_disponibility')
								}}>
									{"Averiguar Disponibilidad"}
								</button>
							);
					}}
				/>
			</Table>
		</>
	);
};
